import React, { useState } from 'react'
import styles from './styles.module.css'
import starIcon from '../../../img/starIcon.svg'

function Reviews ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Check if 'record.reviews' is an array. If true, process it, otherwise return an empty array.
  const sortedReviews = Array.isArray(record.reviews)
    ? record.reviews
        // Map over each review to add 'category' and 'parsedDate' properties.
        .map(review => {
          // Parse the review date into a JavaScript Date object
          const date = new Date(review.date)
          // Check if the date is valid (isNaN checks for invalid dates)
          const hasValidDate = !isNaN(date)
          // Check if the review has a rating (it should not be undefined or null)
          const hasRating =
            review.rating !== undefined && review.rating !== null

          // Assign category based on valid date and rating
          let category
          if (hasValidDate && hasRating) {
            category = 1 // Category 1: Valid date and rating
          } else if (hasValidDate && !hasRating) {
            category = 2 // Category 2: Valid date but missing rating
          } else {
            category = 3 // Category 3: Missing valid date
          }

          // Return a new review object with the added 'category' and 'parsedDate' fields
          return { ...review, category, parsedDate: date }
        })
        // Sort the reviews by category, and by date for certain categories
        .sort((a, b) => {
          // First, sort by category: 1, 2, 3
          if (a.category !== b.category) {
            return a.category - b.category // Sort by category in ascending order
          }
          // For Categories 1 and 2, sort by 'parsedDate' in descending order (most recent first)
          else if (a.category === 1 || a.category === 2) {
            return b.parsedDate - a.parsedDate // Sort by date descending
          }
          // For Category 3 (missing valid date), keep the original order
          else {
            return 0 // No change in order for Category 3
          }
        })
    : [] // If 'record.reviews' is not an array, return an empty array.

  // Show only 3 reviews unless expanded
  const reviewsToShow = isExpanded ? sortedReviews : sortedReviews.slice(0, 3)

  // Toggle expand/collapse state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const hasReviews = sortedReviews.length > 0

  // Function to render stars based on the rating
  const renderStars = rating => {
    const totalStars = 5
    const filledStars = Math.min(Math.max(rating, 0), totalStars) // Ensure the rating is between 0 and 5

    return (
      <div className={styles.starsContainer}>
        {Array(filledStars)
          .fill()
          .map((_, index) => (
            <img
              key={index}
              src={starIcon}
              alt='filled star'
              width='14'
              height='13'
              className={styles.star}
            />
          ))}
      </div>
    )
  }

  return (
    <section className={styles.containerReviews}>
      <span className={styles.reviewsTitle}>Reviews</span>

      {hasReviews ? (
        <div className={styles.reviewsList}>
          {/* Header */}
          <div className={styles.headerRowReviews}>
            <span className={styles.headerReviews}>Date</span>
            <span className={styles.headerReviews}>Rating</span>
            <span className={styles.headerReviews}>User</span>
            <span className={styles.headerReviews}>Title</span>
            <span className={styles.headerReviews}>Review</span>
            <span className={styles.headerReviews}>URL</span>
          </div>

          {/* Review Rows */}
          {reviewsToShow.map((review, index) => (
            <div key={index} className={styles.reviewRow}>
              <span className={styles.cellReviews}>
                {review?.date && !isNaN(new Date(review.date))
                  ? new Intl.DateTimeFormat('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: '2-digit'
                    }).format(new Date(review.date))
                  : 'N/A'}
              </span>
              <span className={styles.cellReviews}>
                {review.rating ? renderStars(review.rating) : 'N/A'}
              </span>
              <span className={styles.cellReviews}>
                {review.username ? review.username : 'N/A'}
              </span>
              <span className={styles.cellReviews}>
                {review.title ? review.title : 'N/A'}
              </span>
              <span className={styles.cellReviews}>
                {review.text ? review.text : 'N/A'}
              </span>
              <span className={styles.cellReviews}>
                {review.sourceURLs ? review.sourceURLs : 'N/A'}
              </span>
            </div>
          ))}

          {/* Show the expand button only if there are more than 3 reviews */}
          {sortedReviews.length > 3 && (
            <button
              className={styles.expandButtonReviews}
              onClick={toggleExpand}
            >
              {isExpanded
                ? 'Show less'
                : `Expand all (${sortedReviews.length})`}
            </button>
          )}
        </div>
      ) : (
        <div className={styles.noReviews}>N/A</div>
      )}
    </section>
  )
}

export default Reviews
